import React, {useMemo} from 'react';
import DataGrid, {
  Column,
  Editing,
  Paging,
  Scrolling,
  RequiredRule,
  Toolbar,
  Item,
} from 'devextreme-react/data-grid';
import {Popup} from 'devextreme-react/popup';
import Button from 'devextreme-react/button';
import {getDataSource} from 'api/dataSource';
import TagBox from 'devextreme-react/tag-box';
import {FTD_TYPE_LOOKUP} from 'utils/variables';
import {toCommaSeparatedString, toNumberArray} from 'utils/functions';

const formatFtdTypes = (value) => {
  const ids = toNumberArray(value);
  if (!ids.length) return '';
  const map = new Map(FTD_TYPE_LOOKUP.map((item) => [item.id, item.name]));
  return ids.map((id) => map.get(id) || String(id)).join(', ');
};

const FtdTypesCell = ({data}) => <span>{formatFtdTypes(data?.value)}</span>;

const FtdTypesEditCell = ({data}) => {
  const [selectedIds, setSelectedIds] = React.useState(() => toNumberArray(data?.value));

  React.useEffect(() => {
    setSelectedIds(toNumberArray(data?.value));
  }, [data?.value]);

  return (
    <TagBox
      elementAttr={{id: 'ftd-type'}}
      dataSource={FTD_TYPE_LOOKUP}
      displayExpr="name"
      valueExpr="id"
      value={selectedIds}
      searchEnabled={false}
      showSelectionControls={true}
      hideSelectedItems={false}
      showDropDownButton={true}
      applyValueMode="instantly"
      showClearButton={true}
      onValueChanged={(e) => {
        setSelectedIds(e.value);
        data?.setValue?.(e.value);
      }}
    />
  );
};

const RouterProfilePopup = ({haveEnoughRight, onClose}) => {
  const dataSource = useMemo(() => {
    return getDataSource({
      key: 'ID',
      object: 'RouterMerchant',
      defFilter: {
        S3MerchantApiProfileID: {'<>': null},
      },
      columns: ['ID', 'S3MerchantApiProfileID', 'RouterMerchantID', 'FtdTypes', 'FtdCnt'],
      //sorts: ['ID'],
      insertKeys: ['S3MerchantApiProfileID', 'RouterMerchantID', 'FtdTypes', 'FtdCnt'],
      modifier: (items = []) =>
        items.map((row) => ({
          ...row,
          FtdTypes: toNumberArray(row.FtdTypes),
        })),
      paramsModifier: (paramsData) => ({
        ...paramsData,
        FtdTypes: toCommaSeparatedString(paramsData.FtdTypes),
      }),
      loadAll: true
    });
  }, []);

  return (
    <Popup
      visible={true}
      onHiding={onClose}
      title="Профиль мерчанта-Роутинг-Каскадинг"
      width={800}
      height={500}
      maxHeight="90vh"
      container="#main-content"
      deferRendering={false}
      showCloseButton={true}
    >
      <div
        className="router-profile-popup"
      >
        <div
          className={'router-profile-grid-wrapper'}
        >
          <DataGrid
            dataSource={dataSource}
            keyExpr="ID"
            showBorders={true}
            hoverStateEnabled={true}
            repaintChangesOnly={true}
            height="100%"
          >
            <Paging enabled={false}/>

            <Scrolling
              mode="standard"
              showScrollbar="always"
            />

            <Toolbar>
              <Item
                name="addRowButton"
                showText="always"
                options={{text: 'Добавить'}}
              />
            </Toolbar>

            {haveEnoughRight && (
              <Editing
                mode="row"
                allowDeleting={true}
                allowUpdating={true}
                allowAdding={true}
                useIcons={true}
              />
            )}

            <Column
              width={125}
              dataField="S3MerchantApiProfileID"
              caption="ID профиля"
            >
              <RequiredRule message="Обов'язкове поле"/>
            </Column>

            <Column
              width={125}
              dataField="RouterMerchantID"
              caption="ID роутинга"
            >
              <RequiredRule message="Обов'язкове поле"/>
            </Column>

            <Column
              dataField="FtdTypes"
              caption="FTD:Типы платежей"
              cellComponent={FtdTypesCell}
              editCellComponent={FtdTypesEditCell}
            />

            <Column
              width={160}
              dataField="FtdCnt"
              caption="FTD:Кол-во платежей"
            />
          </DataGrid>
        </div>

        <div
          className="router-popup-actions"
        >
          <Button
            text="Закрыть"
            onClick={onClose}
          />
        </div>
      </div>
    </Popup>
  );
};

export default RouterProfilePopup;
